import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button
} from "reactstrap";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../Assets/css/style.css"; // create this file

const AdminLogin = () => {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleLogin = async () => {
    try {
      const res = await axios.post(
        // "http://localhost/qads_interview/admin/login.php",
        "https://interview.qads.co.in/qads_interview/admin/login.php",
        { username, password }
      );

      localStorage.setItem("admin_token", res.data.data.token);
      window.location.href = "/admin-candidates";

    } catch (err) {
      alert("Invalid Credentials");
    }
  };

  return (
    <div className="auth-wrapper">
      <Container className="auth-container">
        <Row className="justify-content-center">
          <Col md="5" lg="4">
            <Card className="auth-card">
              <CardBody>

                <h3 className="auth-title">
                  Admin Login
                </h3>

                <p className="auth-subtitle">
                  Login to manage candidates
                </p>

                <Input
                  placeholder="Username"
                  className="mb-3 auth-input"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />

                <div className="password-wrapper mb-4">
                  <Input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    className="auth-input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />

                  <span
                    className="eye-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                  </span>
                </div>

                <Button
                  className="auth-btn w-100"
                  onClick={handleLogin}>
                  Login
                </Button>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AdminLogin;